var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.417,
    height: 28.123,
    viewBox: "0 0 24.417 28.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 24.417,
    height: 28.123,
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_376",
    "data-name": "Groupe 376",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_346",
    "data-name": "Groupe 346",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2834",
    "data-name": "Trac\\xE9 2834",
    d: "M12.229,7.511a7.528,7.528,0,1,1,7.5,7.529,7.534,7.534,0,0,1-7.5-7.529m7.533-5.548a5.557,5.557,0,1,0,5.56,5.559,5.572,5.572,0,0,0-5.56-5.559",
    transform: "translate(-7.55 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2835",
    "data-name": "Trac\\xE9 2835",
    d: "M11.785,44.407a13.869,13.869,0,0,1,8.926,2.888A9.42,9.42,0,0,1,24.32,53.26a9.247,9.247,0,0,1,.1,1.282.955.955,0,0,1-.89.988.977.977,0,0,1-1.058-.888c-.048-.415-.04-.84-.116-1.249a7.635,7.635,0,0,0-3.3-4.908A11.643,11.643,0,0,0,11.4,46.412a11.3,11.3,0,0,0-6.009,2.047,7.7,7.7,0,0,0-3.332,4.92,11.335,11.335,0,0,0-.11,1.188,1.023,1.023,0,0,1-.717.935.939.939,0,0,1-1.069-.4A1.305,1.305,0,0,1,0,54.465,8.668,8.668,0,0,1,2.181,48.78,12.27,12.27,0,0,1,9.55,44.675c.87-.162,1.761-.213,2.235-.268",
    transform: "translate(0 -27.417)",
    fill: "#015c7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.ee166766979a6d487550c779fd6e6a30.svg";
export { ForwardRef as ReactComponent };